package com.damda.design_system.ui.views.food_carts

import androidx.compose.runtime.Composable
import com.damda.design_system.ui.viewmodels.FoodCartState
import com.damda.design_system.ui.views.compose_migrations.layouts.JSSpacer
import com.damda.design_system.ui.views.compose_migrations.layouts.QuantitySelector
import com.damda.design_system.ui.views.compose_migrations.texts.StyledText
import com.damda.design_system.ui.views.lists.FoodItem
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.boxSizing
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flex
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginRight
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img

@Composable
fun FoodCartList(foodCartState: FoodCartState, resizeFontSize: CSSSizeValue<CSSUnit.px> = 0.px) {
    Div({
        style {
            width(100.percent)
            height(auto)
            padding(16.px)
            boxSizing("border-box")
        }
    }) {
        foodCartState.cartItems.forEach { (foodItem, _) ->
            val quantity = foodCartState.cartItems[foodItem] ?: 0
            if (quantity > 0) {
                FoodCartItem(
                    item = foodItem,
                    quantity = quantity,
                    resizeFontSize = resizeFontSize,
                    onIncrement = { foodCartState.addToCart(foodItem) },
                    onDecrement = { foodCartState.removeFromCart(foodItem) }
                )
            }
        }
    }
}

@Composable
fun FoodCartItem(
    item: FoodItem,
    quantity: Int,
    resizeFontSize: CSSSizeValue<CSSUnit.px> = 0.px,
    onIncrement: () -> Unit,
    onDecrement: () -> Unit
) {
    Div({
        style {
            padding(8.px)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Row)
            alignItems(AlignItems.Center)
            backgroundColor(Color.white)
            borderRadius(16.px)
            property("box-shadow", "0px 4px 4px rgba(0, 0, 0, 0.25)")
            marginBottom(16.px)
            boxSizing("border-box")
        }
    }) {
        Img(src = item.imageName, alt = item.title) {
            style {
                width(64.px)
                height(64.px)
                borderRadius(8.px)
                property("object-fit", "cover")
                marginRight(16.px)
            }
        }
        Div({
            style {
                flex(1)
            }
        }) {
            StyledText(
                item.title,
                fontSize = 20.px - resizeFontSize,
                color = Color.black
            )
            JSSpacer(height = 4.px)
            StyledText(
                item.subtitle,
                fontSize = 18.px - resizeFontSize,
                color = Color.gray
            )
            JSSpacer(height = 4.px)
            StyledText(
                item.price,
                fontSize = 18.px - resizeFontSize,
                color = Color("#FF5722")
            )
            JSSpacer(height = 4.px)
        }
        QuantitySelector(quantity, isDecrementFilter = quantity > 0, onIncrement = onIncrement, onDecrement = onDecrement, width = 52.px, height = 20.px)
    }
}